import domainTransformer from '../../game/transformers/domain';

export default function userTransformer(user) {
  return {
    ...user,
    domains: user.domains.map(domainTransformer),
  };
}
